"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var Dialog = __importStar(require("@radix-ui/react-dialog"));
var solid_1 = require("@heroicons/react/solid");
var DialogComp = function (_a) {
    var handleCloseDialog = _a.handleCloseDialog, children = _a.children, isOpen = _a.isOpen, title = _a.title;
    var closeButtonRef = React.useRef(null);
    return ((0, jsx_runtime_1.jsx)(Dialog.Root, { open: isOpen, children: (0, jsx_runtime_1.jsxs)(Dialog.Portal, { children: [(0, jsx_runtime_1.jsx)(Dialog.Overlay, { "data-sr-feedback-widget-overlay": "" }), (0, jsx_runtime_1.jsxs)(Dialog.Content, { "data-sr-feedback-widget-content": "", onEscapeKeyDown: handleCloseDialog, children: [(0, jsx_runtime_1.jsx)(CloseButton, { ref: closeButtonRef, handleCloseDialog: handleCloseDialog }), (0, jsx_runtime_1.jsx)(Dialog.Title, { "data-sr-feedback-widget-title": "", children: title }), children] })] }) }));
};
var CloseButton = React.forwardRef(function (_a, ref) {
    var handleCloseDialog = _a.handleCloseDialog;
    return ((0, jsx_runtime_1.jsx)("div", { "data-sr-feedback-widget-close": "", children: (0, jsx_runtime_1.jsxs)("button", { ref: ref, type: "button", onClick: handleCloseDialog, children: [(0, jsx_runtime_1.jsx)(solid_1.XIcon, { className: "h-5 w-5", "aria-hidden": "true" }), (0, jsx_runtime_1.jsx)("span", { className: "sr-only", children: "Close feedback dialog" })] }) }));
});
exports.default = DialogComp;
